<div
  class="page-container"
  [ngClass]="isTeamView ? 'gradient-team' : 'gradient-user'"
>
  <div class="dashboard-header">
    <app-title
      [title]="'Home'"
      [uploadDisabled]="uploadDisabled"
    ></app-title>

    <div class="msg">
      <h3 class="color-white marg-0 font-we-400">{{ message }}</h3>
    </div>
  </div>

  <div style="padding-top: 25px">
    <div class="dashboard-header">
      <app-dashboard-tabs [isTeamView]="isTeamView"></app-dashboard-tabs>
    </div>
  </div>
  <div style="clear: both"></div>
  <!-- Documenti -->
  <div style="padding-top: 25px">
    <app-documents
      [docFirst]="docFirst"
      [docLength]="docLength"
      [isTeamView]="isTeamView"
    ></app-documents>
  </div>
</div>
